module.exports = __webpack_public_path__ + "img/qiub_03.91278c66.png";